import { ApprovingInvoiceReportFormInputValue } from 'ap-openapi';

export const processLabels = (
  inputValues: ApprovingInvoiceReportFormInputValue[]
) => {
  if (!inputValues) {
    return [];
  }

  return inputValues.map((value, index) => {
    const isLast = index === inputValues.length - 1;
    const label = value?.label ? value?.label + (isLast ? '' : ', ') : '';
    return {
      id: value?.id ?? `empty-${index}`,
      label,
      value: value?.value ?? null,
    };
  });
};

// help split file name and extension
export const splitFileNameExtension = (fileName: string) => {
  if (!fileName) {
    return { name: '', extension: '' };
  }
  const lastDotIndex = fileName.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return { name: fileName, extension: '' };
  }
  return {
    name: fileName?.substring(0, lastDotIndex),
    extension: fileName?.substring(lastDotIndex + 1),
  };
};
